import { types } from '../actions/types';

const DEFAULT_STATE = {
    textColor: 'white',
    color: 'black',
    message: '',
    visible: false,
    duration: 3000,
    notifications: {
        bookings: [],
        chatMessages: [],
        nutritionLogs: [],
        nutritionLogLikes: [],
        nutritionLogReviews: [],
        nutritionLogComments: [],
        expertContent: [],
    },
    unreadCount: {},
};

export default (state = DEFAULT_STATE, { type, payload, id = null }) => {
    
    switch (type) {
        case types.NOTIFICATION_SENT:
            const { color, message, visible, duration, textColor } = payload;
            return {
                ...state, color, message, visible, duration, textColor
            }
        case types.HIDE_NOTIFICATION:
            return {
                ...state, visible: payload
            }
        case types.CLEAR_NOTIFICATIONS:
            // console.log('NOTIFICATIONS CLEARED');
            return {
                ...state, 
                notifications: {
                    ...DEFAULT_STATE.notifications
                }
            }
        case types.GET_NEW_BOOKINGS_NOTIFICATION_SUCCESS:
            return {
                ...state, 
                notifications: {
                    ...state.notifications,
                    bookings: (state.notifications && state.notifications.bookings && state.notifications.bookings.length > 0) ? [...state.notifications.bookings, ...payload] : [...payload]
                }
            }
        case types.GET_NEW_CHAT_NOTIFICATION_SUCCESS:
            // console.log('@REDUCER NEW CHAT NOTIFICATIONS', payload, state);
            return {
                ...state, 
                notifications: {
                    ...state.notifications,
                    chatMessages: (state.notifications && state.notifications.chatMessages && state.notifications.chatMessages.length > 0) ? [...state.notifications.chatMessages, ...payload] : [...payload]
                }
            }
        case types.GET_NEW_EXPERT_CONTENT_NOTIFICATION_SUCCESS:
            // console.log('@REDUCER NEW EXPERT CONTENT NOTIFICATIONS', payload, state);
            return {
                ...state, 
                notifications: {
                    ...state.notifications,
                    expertContent: (state.notifications && state.notifications.expertContent && state.notifications.expertContent.length > 0) ? [...state.notifications.expertContent, ...payload] : [...payload]
                }
            }
        case types.GET_NEW_NUTRITION_LOG_COMMENTS_NOTIFICATION_SUCCESS:
            return {
                ...state, 
                notifications: {
                    ...state.notifications,
                    nutritionLogComments: (state.notifications && state.notifications.nutritionLogComments && state.notifications.nutritionLogComments.length > 0) ? [...state.notifications.nutritionLogComments, ...payload] : [...payload]
                }
            }
        case types.GET_NEW_NUTRITION_LOG_LIKES_NOTIFICATION_SUCCESS:
            return {
                ...state, 
                notifications: {
                    ...state.notifications,
                    nutritionLogLikes: (state.notifications && state.notifications.nutritionLogLikes && state.notifications.nutritionLogLikes.length > 0) ? [...state.notifications.nutritionLogLikes, ...payload] : [...payload]
                }
            }
        case types.GET_NEW_NUTRITION_LOG_NOTIFICATION_SUCCESS:
            return {
                ...state, 
                notifications: {
                    ...state.notifications,
                    nutritionLogs: (state.notifications && state.notifications.nutritionLogs && state.notifications.nutritionLogs.length > 0 ) ? [...state.notifications.nutritionLogs, ...payload] : [...payload]
                }
            }
        case types.GET_NEW_NUTRITION_LOG_REVIEWS_NOTIFICATION_SUCCESS:
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    nutritionLogReviews: (state.notifications && state.notifications.nutritionLogReviews && state.notifications.nutritionLogReviews.length > 0) ? [...state.notifications.nutritionLogReviews, ...payload] : [...payload]
                }
            }
        case types.GET_TOTAL_UNREAD_COUNT:
            console.log('UNREAD COUNT RECEIVED @ REDUCER TOTAL COUNT', payload, state.unreadCount && Object.keys(state.unreadCount).length > 0);
            return {
                ...state,
                unreadCount: (state.unreadCount && Object.keys(state.unreadCount).length > 0)
                ? {
                    ...state.unreadCount,
                    ...payload
                }
                : {
                    ...payload
                }
            }
        case types.RESET_TOTAL_UNREAD_COUNT:
            console.log('UNREAD COUNT RESET RECEIVED @ REDUCER');
            return {
                ...state,
                unreadCount: {}
            }
            
            
        // case types.GET_NL_COMMENT_COUNT:
        //     console.log('UNREAD COUNT FOR LOG COMMENTS', payload, id)
        //     if (state[state.unreadCount[id]] && state[state.unreadCount[id]].nlComments) {
        //         return {
        //             ...state,
        //             unreadCount: {
        //                 ...state.unreadCount,
        //                 [id]: {
        //                     ...state[state.unreadCount[id]],
        //                     nlComments: payload
        //                 }
        //             }
        //         }
        //     }
        //     return {
        //         ...state,
        //         unreadCount: {
        //             ...state.unreadCount,
        //             [id]: {
        //                 nlComments: payload
        //             }
        //         }
        //     }
        // case types.GET_NL_COUNT:
        //     console.log('UNREAD COUNT FOR LOGS', payload, id)
        //     if (state[state.unreadCount[id]] && state[state.unreadCount[id]].nls) {
        //         return {
        //             ...state,
        //             unreadCount: {
        //                 ...state.unreadCount,
        //                 [id]: {
        //                     ...state[state.unreadCount[id]],
        //                     nls: payload
        //                 }
        //             }
        //         }
        //     }
        //     return {
        //         ...state,
        //         unreadCount: {
        //             ...state.unreadCount,
        //             [id]: {
        //                 nls: payload
        //             }
        //         }
        //     }
        // case types.GET_NL_REVIEW_COUNT:
        //     console.log('UNREAD COUNT FOR LOG REVIEW', payload, id)
        //     if (state[state.unreadCount[id]] && state[state.unreadCount[id]].nlReview) {
        //         return {
        //             ...state,
        //             unreadCount: {
        //                 ...state.unreadCount,
        //                 [id]: {
        //                     ...state[state.unreadCount[id]],
        //                     nlReviews: payload
        //                 }
        //             }
        //         }
        //     }
        //     return {
        //         ...state,
        //         unreadCount: {
        //             ...state.unreadCount,
        //             [id]: {
        //                 nlReviews: payload
        //             }
        //         }
        //     }
        // case types.GET_BOOKING_COUNT:
        //     console.log('UNREAD COUNT FOR BOOKINGS', payload, id)
        //     if (state[state.unreadCount[id]] && state[state.unreadCount[id]]) {
        //         return {
        //             ...state,
        //             unreadCount: {
        //                 ...state.unreadCount,
        //                 [id]: {
        //                     ...state[state.unreadCount[id]],
        //                     bookings: payload
        //                 }
        //             }
        //         }
        //     }
        //     return {
        //         ...state,
        //         unreadCount: {
        //             ...state.unreadCount,
        //             [id]: {
        //                 bookings: payload
        //             }
        //         }
        //     }
        // case types.GET_CHAT_COUNT:
        //     console.log('UNREAD COUNT FOR CHAT', payload, id)
        //     if (state[state.unreadCount[id]]) {
        //         return {
        //             ...state,
        //             unreadCount: {
        //                 ...state.unreadCount,
        //                 [id]: {
        //                     ...state[state.unreadCount[id]],
        //                     chatMessages: payload
        //                 }
        //             }
        //         }
        //     }
        //     return {
        //         ...state,
        //         unreadCount: {
        //             ...state.unreadCount,
        //             [id]: {
        //                 chatMessages: payload
        //             }
        //         }
        //     }
        // case types.GET_EXPERT_CONTENT_COUNT:
        //     console.log('UNREAD COUNT FOR EXPERT CONTENT', payload, id)
        //     if (state[state.unreadCount[id]]) {
        //         return {
        //             ...state,
        //             unreadCount: {
        //                 ...state.unreadCount,
        //                 [id]: {
        //                     ...state[state.unreadCount[id]],
        //                     expertContent: payload
        //                 }
        //             }
        //         }
        //     }
        //     return {
        //         ...state,
        //         unreadCount: {
        //             ...state.unreadCount,
        //             [id]: {
        //                 expertContent: payload
        //             }
        //         }
        //     }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/notification-reducer.js